var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn",style:(`background: ${_vm.background};`),domProps:{"textContent":_vm._s(_vm.action.title)},on:{"click":function($event){return _vm.handleButtonPress(_vm.action)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }